import BaseModel from 'volta/models/base-model';

import { attr } from '@ember-data/model';

export default class UserProfile extends BaseModel {
  /**
   * Attributes
   */

  @attr('string') login?: string;
  @attr('string') firstName?: string;
  @attr('string') middleName?: string;
  @attr('string') lastName?: string;
  @attr('string') email?: string;
  @attr('boolean', { defaultValue: false }) connected!: boolean;

  /**
   * Getters
   */

  get userId() {
    return this.id;
  }

  get fullName() {
    const middleName = `${this.middleName ? ' ' + this.middleName + ' ' : ''}`;
    return `${this.firstName ?? ''}${middleName} ${this.lastName ?? ''}`.trim();
  }

  get displayName() {
    return this.fullName && this.fullName !== '' ? this.fullName : this.login;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'user-profile': UserProfile;
  }
}
